
import {login} from "../helpers/auth";
import {validationHandlerEmailProfile, validationHandlerPassword} from "../helpers/fieldsHandler";
import {errorAuthHandler} from "../helpers/errorsHandler";

export default {
  name: 'PageSignUp',
  data () {
    return {
      fields: {
        email: '',
        password: '',
        checked: false
      },
      errors: {
        emailErrorMessages: '',
        passwordErrorMessages: ''
      },
      alert: {
        show: false,
        text: ''
      }
    }
  },
  computed: {
    validateEmail: function(){
      return validationHandlerEmailProfile(this.fields.email)
    },
    validatePassword: function(){
      return validationHandlerPassword(this.fields.password)
    }
  },
  methods: {
    async submitForm(e){
      e.preventDefault()
      if(this.validateEmail.length < 1 && this.validatePassword.length < 1 && this.fields.checked){
        try {
          const res = await this.$axios.post('/customers', {email: this.fields.email,password: this.fields.password})
          // const res = await login(this,{email: this.fields.email,password: this.fields.password})
          if(res) {
            await this.$router.push('/verify-email')
          }
        }catch (e) {
          this.alert.show = true
          this.alert.text = errorAuthHandler(e.message)
        }
      }else {
        if(!this.fields.checked){
          this.alert.show = true
          this.alert.text = "Please read and accept Terms of Use and Privacy Policy"
        }
        this.errors.emailErrorMessages = this.validateEmail
        this.errors.passwordErrorMessages = this.validatePassword
      }
    },
    focusoutEmailInput (){
     this.errors.emailErrorMessages = this.validateEmail
    },
    focusoutPasswordInput(){
      this.errors.passwordErrorMessages = this.validatePassword
    }
  }
}
